.title {
    color: #000;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: 28px;
    padding: 0.8rem 1rem;
}

.cardBody {
    padding: 1rem;
    width: 50%;
}

.userInfo,
.roleSelection {
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

.sectionTitle {
    font-size: 1.125rem;
    font-weight: 600;
    color: #1e293b;
    margin: 0;
    border-bottom: 1px solid #e2e8f0;
    padding-bottom: 0.5rem;
}

.formField {
    display: flex;
    flex-direction: column;
    gap: 0.375rem;
}

.fieldLabel {
    font-size: 0.875rem;
    font-weight: 500;
    color: #334155;
}

.fieldInput {
    height: 2.5rem;
    padding: 0 0.875rem;
    font-size: 0.875rem;
    border: 1px solid #e2e8f0;
    border-radius: 0.5rem;
    background-color: #f8fafc;
    color: #334155;
    outline: none;
    width: 100%;
    box-sizing: border-box;
    transition: border-color 0.2s ease, box-shadow 0.2s ease;

    &:focus {
        border-color: #3b82f6;
        box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.15);
    }

    &:read-only {
        background-color: #f1f5f9;
        cursor: not-allowed;
    }
}

.select {
    height: 2.5rem;
    padding: 0 0.875rem;
    font-size: 0.875rem;
    border: 1px solid #e2e8f0;
    border-radius: 0.5rem;
    background-color: #ffffff;
    color: #334155;
    outline: none;
    width: 100%;
    box-sizing: border-box;
    transition: border-color 0.2s ease, box-shadow 0.2s ease;

    &:focus {
        border-color: #3b82f6;
        box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.15);
    }

    &:disabled {
        background-color: #f1f5f9;
        cursor: not-allowed;
    }
}

.selectedRoles {
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
    margin-top: 0.5rem;
}

.roleTag {
    display: inline-flex;
    align-items: center;
    gap: 0.375rem;
    padding: 0.25rem 0.5rem;
    font-size: 0.75rem;
    font-weight: 500;
    color: #ffffff;
    background-color: #3b82f6;
    border-radius: 0.375rem;
}

.removeRole {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 1rem;
    height: 1rem;
    background: transparent;
    border: none;
    border-radius: 50%;
    cursor: pointer;
    color: #ffffff;
    opacity: 0.8;
    transition: opacity 0.2s ease;

    &:hover {
        opacity: 1;
    }

    &:disabled {
        cursor: not-allowed;
        opacity: 0.5;
    }
}

.required {
    color: #ef4444;
}

.formActions {
    display: flex;
    justify-content: flex-end;
    gap: 0.75rem;
    padding-top: 3rem;
}

.cnloutlineCustom {
  border: 1px solid #90A1B9;
}